import {
  size,
  colors,
  mediaQueries,
  typography,
  Row as RawRow,
  Container as RawContainer,
} from '@everlywell/leaves';
import styled from 'styled-components';

export const SectionWrapper = styled.div`
  display: block;

  ${mediaQueries.forDesktopUp} {
    display: flex;
  }
`;

export const Headline = styled.h1`
  ${typography.h1Text};
  margin: ${size.md}px 0;
`;

export const Container = styled(RawContainer)`
  position: relative;
  overflow: hidden;
  padding-bottom: 950px;

  @media screen and (max-width: 450px) {
    padding-bottom: 1640px;
  }
`;

export const Row = styled(RawRow)``;

export const IFrame = styled.iframe`
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
  max-height: calc(100% - 258px);

  ${mediaQueries.forTabletHorizontalUp} {
    margin: 0 24px;
  }

  ${mediaQueries.forDesktopUp} {
    margin: 0 48px;
  }
`;

export const SubTitle = styled.h2`
  ${typography.overlineText}
  color: ${colors.teal4};
  font-weight: ${typography.weight.bold};
`;
